import {
	GetPlayerDataListRequest,
	GetPlayerDataListResponse,
} from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPlayerDataList } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetPlayerDataList(
	payload: GetPlayerDataListRequest,
	props?: UseBaseQueryOptions<GetPlayerDataListResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetPlayerDataList, payload],
		queryFn: () => getPlayerDataList(payload),
		...props,
	})
}
